import { gql } from '@apollo/client';

const TaxEvidenceInfo = gql`
  fragment TaxEvidenceInfo on TaxEvidence {
    id
    description
    effectiveAt
    evidenceType
    evidenceableId
    evidenceableType
    expiresAt
    issuedOn
    referenceUrl
    rejectionReason
    replacedById
    reviewAt
    s3Key
    sourceOrganization
    state
    title
    verifiedAt
    verifiedById
  }
`;

export default TaxEvidenceInfo;
